import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Portuguese month names
export const MONTH_NAMES_PT = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

// Race type labels in Portuguese
export const RACE_TYPE_LABELS = {
  road: 'Estrada',
  trail: 'Trail',
  colectividades: 'Colectividades',
  walk: 'Caminhada',
  kids: 'Kids'
};

// Race type colors
export const RACE_TYPE_COLORS = {
  road: 'slate',
  trail: 'green',
  colectividades: 'violet',
  walk: 'sky',
  kids: 'amber'
};

// Format date to Portuguese locale
export const formatDatePT = (dateStr) => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = MONTH_NAMES_PT[date.getMonth()];
  return `${day} de ${month}`;
};

// Format date for display with weekday
export const formatDateFull = (dateStr) => {
  const date = new Date(dateStr);
  const options = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('pt-PT', options);
};

// Get month number from date string
export const getMonthFromDate = (dateStr) => {
  return new Date(dateStr).getMonth() + 1;
};

// Group races by month
export const groupRacesByMonth = (races) => {
  const grouped = {};
  
  races.forEach(race => {
    const month = getMonthFromDate(race.date);
    if (!grouped[month]) {
      grouped[month] = [];
    }
    grouped[month].push(race);
  });
  
  // Sort races within each month by date
  Object.keys(grouped).forEach(month => {
    grouped[month].sort((a, b) => new Date(a.date) - new Date(b.date));
  });
  
  return grouped;
};

// Get badge class for race type
export const getRaceTypeBadgeClass = (type) => {
  const classes = {
    road: 'bg-slate-700 text-white',
    trail: 'bg-green-700 text-white',
    colectividades: 'bg-violet-600 text-white',
    walk: 'bg-sky-600 text-white',
    kids: 'bg-amber-500 text-white'
  };
  return classes[type] || classes.road;
};

// Get border class for race card
export const getRaceTypeBorderClass = (type) => {
  const classes = {
    road: 'border-l-slate-700',
    trail: 'border-l-green-700',
    colectividades: 'border-l-violet-600',
    walk: 'border-l-sky-600',
    kids: 'border-l-amber-500'
  };
  return classes[type] || classes.road;
};
